import { RootState } from '../store';

const select = (state: RootState) => state.invoices;

export const selectinvoicesData = (state: RootState) => select(state);

export const getSort = (state: RootState) => select(state).sort;
